export default __webpack_public_path__ + "static/media/bus.e123d97b.png";